const PAYMENT_API_BASE_URL =
  'https://us-central1-gratify-ke.cloudfunctions.net/sendMoneyApi';

function normalizePhoneNumber(phone) {
  const digits = String(phone || '').replace(/\D/g, '');

  if (!digits) {
    return '';
  }

  if (digits.startsWith('0') && digits.length === 10) {
    return `254${digits.slice(1)}`;
  }

  if (digits.startsWith('254') && digits.length === 12) {
    return digits;
  }

  return digits;
}

async function postJson(baseUrl, path, payload) {
  const response = await fetch(`${baseUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  if (!response.ok) {
    throw new Error(
      data?.message ||
        data?.error ||
        `Payment request failed with status ${response.status}.`
    );
  }

  return data;
}

async function initiatePayment({
  phone,
  amount,
  payerPhone,
  recipientUserId,
  recipientName,
  recipientPhoneNumber,
  rating,
  comment,
}) {
  return postJson(PAYMENT_API_BASE_URL, '/stkpush', {
    phone: normalizePhoneNumber(phone),
    amount,
    payerPhone: normalizePhoneNumber(payerPhone || phone),
    recipientUserId: recipientUserId || '',
    recipientName: recipientName || '',
    recipientPhoneNumber: normalizePhoneNumber(recipientPhoneNumber || ''),
    rating: Number.isInteger(rating) ? rating : null,
    comment: comment || '',
  });
}

async function getPublicProfile(tipToken) {
  const response = await fetch(
    `${PAYMENT_API_BASE_URL}/profile?token=${encodeURIComponent(String(tipToken || '').trim())}`
  );
  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.error || 'This Gratify profile is unavailable.');
  }

  return data?.profile || null;
}

async function verifyPayment(checkoutRequestID) {
  return postJson(PAYMENT_API_BASE_URL, '/query', {
    queryCode: checkoutRequestID,
  });
}

export { getPublicProfile, initiatePayment, normalizePhoneNumber, verifyPayment };
